import { Lottie } from "src/components/Lottie";
import { H2, Subtitle } from "src/atoms/typography";
import { useTranslation } from "react-i18next";
import { getLocale } from "src/utils/locale";
import NoteContainer from "src/components/NoteContainer";
import environment from "src/utils/environment";
import { Flex, useColorModeValue, Button } from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";
import getImageSrc from "src/utils/getImageSrc";
import { SceneLayout } from "src/components/SceneLayout";
import NavigationButtons from "src/components/NavigationButtons";

export default function Step({
  onClick,
  animationName,
  mediaProps,
  heading,
  subtitle,
  noteKey,
  Note,
  imageName,
  buttonStringKey,
  flow
}) {
  const { t } = useTranslation();

  return (
    <>
      {flow.history["0"] === "second" && (
        <NavigationButtons
          mode="fullScreen"
          onBack={() => {
            flow.previous();
          }}
        />
      )}
      <SceneLayout
        centerProps={{
          textAlign: "center"
        }}
        center={
          <Flex>
            <Flex w="336px" flexDir="column" alignItems="center">
              {animationName && <Lottie animationName={animationName} {...mediaProps} />}
              {imageName && <Image src={getImageSrc(imageName)} {...mediaProps} />}
              <H2
                width={environment.isBarkio && getLocale() === "ru" ? "400px" : "320px"}
                mt="16px"
                color="highEmphasis"
              >
                {heading}
              </H2>
              <Subtitle mt="8px" color="mediumEmphasis">
                {t(subtitle)}
              </Subtitle>
              <NoteContainer>{Note ? Note : t(noteKey)}</NoteContainer>
            </Flex>
          </Flex>
        }
        bottom={<Button onClick={onClick}>{t(buttonStringKey)}</Button>}
        bottomProps={{ mb: "1.5rem" }}
      />
    </>
  );
}
